import React from 'react';

interface HorizontalLineProps {
  options?: Options;
}

export interface Options {
  color?: string;
  width?: string;
  margin?: string;
}

const defaultOptions: Options = {
  color: 'white',
  width: '100%',
  margin: '20px 0'
};

const HorizontalLine: React.FC<HorizontalLineProps> = ({ options }) => {
  const optionsToUse: Options = { ...defaultOptions, ...options };

  return (
    <hr
      style={{
        height: '1px',
        margin: optionsToUse.margin,
        width: optionsToUse.width,
        color: optionsToUse.color
      }}
    />
  );
};

export { HorizontalLine };
